module.exports = __webpack_public_path__ + "static/media/Bupa_logo.92c2122e.svg";